import {Component} from '@angular/core';
import {AsyncPipe, DatePipe} from "@angular/common";
import {
    DxDateRangeBoxComponent, DxFormComponent,
    DxTextAreaComponent, DxValidatorComponent
} from "devextreme-angular";
import {PicturedItemSelectBoxComponent} from "../../../../../components";
import TimeOffPopupComponent from "../../time-off-popup.component";
import {
    AccessType,
    ChangeVacationStatusCommand,
    CreateVacationCommand, EmployeeDto, GetVacationConflictsQuery, PermissionType,
    TimeOffStatus, VacationConflictDto,
    VacationGridViewDto
} from "@services";
import {DxiItemComponent, DxiValidationRuleComponent} from "devextreme-angular/ui/nested";
import {TimeOffRequestModalComponent} from "../../time-off-request-modal/time-off-request-modal.component";
import {Observable, of} from "rxjs";

@Component({
    selector: 'app-vacation-popup',
    imports: [
        AsyncPipe,
        DatePipe,
        DxDateRangeBoxComponent,
        DxTextAreaComponent,
        PicturedItemSelectBoxComponent,
        DxFormComponent,
        DxValidatorComponent,
        DxiItemComponent,
        DxiValidationRuleComponent,
        TimeOffRequestModalComponent
    ],
    templateUrl: './vacation-popup.component.html'
})
export class VacationPopupComponent extends TimeOffPopupComponent<VacationGridViewDto> {
    conflicts: Observable<VacationConflictDto[]> = of([]);
    protected TimeOffStatus = TimeOffStatus;

    async loadData() {
        this.conflicts = of([]);
        if (this.request) {
            this.formData = new VacationGridViewDto();
            this.formData.init(this.request);
        } else {
            this.formData = new VacationGridViewDto();
            this.formData.init({
                employee: this.canShowInSelectBox ? new EmployeeDto({id: this.auth.userId}) : new EmployeeDto()
            });
            this.formData.requestedStartDate = null;
            this.formData.requestedEndDate = null
        }
        this.employeeId.next(this.formData.employee.id);
        this.startDate.next(this.formData.requestedStartDate);
        this.endDate.next(this.formData.requestedEndDate);
    }

    onPopupShown() {
        if (this.request && this.auth.checkPermission(PermissionType.VacationRequests, AccessType.Manage)) {
            this.conflicts = this.timeOffClient.getVacationConflicts(new GetVacationConflictsQuery({
                vacationId: this.formData.id
            }));
        }
    }

    onSave() {
        let createVacationCommand = new CreateVacationCommand({
            requestedStartDate: this.formData.requestedStartDate,
            requestedEndDate: this.formData.requestedEndDate,
            userId: this.formData.employee.id,
            description: this.formData.description
        });

        this.timeOffClient.createVacation(createVacationCommand).subscribe({
            next: () => this.handleSuccess(),
            error: (errors) => this.handleError(errors)
        });
    };

    changeStatus(status: TimeOffStatus) {
        let changeStatusCommand = new ChangeVacationStatusCommand({
            id: this.formData.id,
            status: status
        });

        this.timeOffClient.changeVacationStatus(changeStatusCommand).subscribe({
            next: () => this.handleSuccess(),
            error: (errors) => this.handleError(errors)
        });
    }

    protected override get canApprove(): boolean {
        return super.canApprove && this.auth.checkPermission(PermissionType.VacationRequests, AccessType.Manage);
    };

    protected override get canDecline(): boolean {
        return super.canDecline && this.auth.checkPermission(PermissionType.VacationRequests, AccessType.Manage);
    };

    protected get canEditEmployee(): boolean{
        return super.canEditEmployee && this.auth.checkPermission(PermissionType.VacationRequests, AccessType.Manage);
    }
}
